<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">Battleground</p>
<p class="sub-title">From the Channel to the  Ypres Salient</p>
<div class="img_container">
<img alt="images" src="images/f000i-01.jpg"/>
<p class="caption">King Albert of the Belgians and his Queen, Elisabeth of Bavaria, played a vital part in the portrayal of Belgium to the world and in maintaining the morale of a nation that had been reduced by the end of 1914 to a faint shadow of its pre-August 1914 self. They represented Belgium’s courage and endurance in adversity. He had a physical advantage in that he was a very tall man, which made him easily recognisable in group photographs of allied commanders or political personalities. Albert, beside his constitutional role (which was substantial), was also a military commander: in September 1918 he led the attack from the sea to Ypres, commanding Army Group Flanders, against Germany’s northern flank. It was Belgian troops, for example, that finally liberated Passchendaele.</p>
</div>
<a id="page_ii"></a>
<div class="img_container">
<img alt="images" src="images/f00ii.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?7fbec7e2